/**
 * Created by calhosh on 7/13/2017.
 */
import MotifToast from '@ey/motif-react-wrapper/Toast';
import React from 'react';

export default function Toast(props) {
	const {variant, actionName, actionOnClick, onClose, position, duration, children, className} = props;

	return (
		<MotifToast
			variant={variant}
			actionName={actionName}
			actionOnClick={actionOnClick}
			onClose={onClose}
			position={position}
			duration={duration}
			className={className}
		>
			{children}
		</MotifToast>
	);
}
